import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

function TagBadge({ tag, onRemove, showRemove = true }) {
  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove(tag);
    }
  };

  return (
    <Badge
      bg="secondary"
      className="d-flex align-items-center gap-1 px-2 py-1"
      style={{
        backgroundColor: tag.color || '#6c757d',
        color: '#fff',
        fontSize: '0.75rem',
        fontWeight: '500',
        borderRadius: '12px',
        cursor: onRemove ? 'pointer' : 'default',
      }}
    >
      <span>{tag.name}</span>
      {showRemove && onRemove && (
        <FaTimes
          size={10}
          onClick={handleRemove}
          style={{
            cursor: 'pointer',
            opacity: 0.8,
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = 1;
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = 0.8;
          }}
        />
      )}
    </Badge>
  );
}

TagBadge.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool,
};

TagBadge.defaultProps = {
  onRemove: null,
  showRemove: true,
};

export default TagBadge;
